import { render } from "./user-settings.vue?vue&type=template&id=610b584f&scoped=true"
import script from "./user-settings.vue?vue&type=script&lang=js"
export * from "./user-settings.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-610b584f"

export default script